import { errorsOf, reviewRoom } from "../survey/checks";
import type { Project, RevisionRecord } from "./model";

export type StepKey = "site" | "rooms" | "design" | "render" | "sign" | "send";

export interface Step {
  key: StepKey;
  title: string;
  done: boolean;
  detail: string;
}

export function latestRevision(p: Project): RevisionRecord | undefined {
  return p.revisions[p.revisions.length - 1];
}

/** Sent and nothing changed since. */
export function isSent(p: Project): boolean {
  const r = latestRevision(p);
  return Boolean(r && r.state === "sent" && r.created_at >= p.edited_at);
}

export function steps(p: Project): Step[] {
  const roomErrors = p.rooms.map((r) => errorsOf(reviewRoom(r)).length);
  const roomsDone = p.rooms.length > 0 && roomErrors.every((n) => n === 0);
  const r = latestRevision(p);
  const choiceCount = Object.values(p.choices).filter((v) => v?.trim()).length;
  return [
    {
      key: "site",
      title: "Захиалагч",
      done: Boolean(p.site.address.trim() && p.site.customer_name.trim()),
      detail: p.site.customer_name || "Хаяг, харилцагч",
    },
    {
      key: "rooms",
      title: "Хэмжилт",
      done: roomsDone,
      detail: p.rooms.length ? `${p.rooms.length} өрөө${roomsDone ? "" : ` · ${roomErrors.reduce((a, b) => a + b, 0)} дутуу`}` : "Өрөө нэмэх",
    },
    {
      key: "design",
      title: "Загвар",
      done: p.picks.length > 0 || choiceCount > 0,
      detail: p.picks.length ? `${p.picks.length} бараа` : choiceCount ? `${choiceCount} сонголт` : "Материал, тоноглол",
    },
    { key: "render", title: "Render", done: Boolean(p.render.approved), detail: p.render.approved ? "Батлагдсан" : "AI зураг" },
    { key: "sign", title: "Гарын үсэг", done: Boolean(p.sign_off), detail: p.sign_off ? p.sign_off.name : "Харилцагч батлах" },
    {
      key: "send",
      title: "Үйлдвэрт илгээх",
      done: isSent(p),
      detail: !r ? "Илгээгээгүй" : r.state === "sent" ? `v${r.revision_no ?? "?"} илгээсэн` : r.state === "rejected" ? "Татгалзсан" : "Дараалалд",
    },
  ];
}

export function statusBadge(p: Project): { label: string; variant: "secondary" | "soft" | "success" | "warning" | "destructive" } {
  const r = latestRevision(p);
  if (r?.state === "rejected") return { label: "Засах шаардлагатай", variant: "destructive" };
  if (isSent(p)) return { label: `Илгээсэн · v${r?.revision_no ?? 1}`, variant: "success" };
  if (r && (r.state === "queued" || r.state === "sending")) return { label: "Илгээх дараалалд", variant: "warning" };
  if (p.rooms.length) return { label: r ? "Өөрчлөгдсөн" : "Хэмжиж байна", variant: "soft" };
  return { label: "Шинэ", variant: "secondary" };
}
